import React, { PropsWithChildren } from "react";

export function RouteWithoutI18n(props: PropsWithChildren<unknown>) {
  return <>{props.children}</>;
}
